import { useState, useEffect, type FormEvent } from 'react'
import { useAuth } from '../state/auth'
import { getBranding, type BrandingState } from '../state/branding'

export function LoginScreen() {
  const { isInitialized, setup, unlock } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [branding, setBrandingState] = useState<BrandingState>({})

  useEffect(() => {
    setBrandingState(getBranding())
  }, [])

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)

    if (!password) {
      setError('Inserisci la master password')
      return
    }

    if (!isInitialized) {
      if (password !== confirm) {
        setError('Le password non coincidono')
        return
      }
      if (password.length < 12) {
        setError('La master password deve avere almeno 12 caratteri')
        return
      }
    }

    setLoading(true)
    try {
      if (isInitialized) {
        await unlock(password)
      } else {
        await setup(password)
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Errore sconosciuto')
    } finally {
      setLoading(false)
    }
  }

  const studioName = branding.name || 'RD Studio'

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="brand">
          {branding.logoBase64 ? (
            <img src={branding.logoBase64} alt={studioName} className="brand-logo" />
          ) : (
            <div className="brand-logo-placeholder">LOGO</div>
          )}
          <h1>{studioName}</h1>
        </div>
        <form onSubmit={handleSubmit}>
          <label>
            Master password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoFocus
              autoComplete={isInitialized ? 'current-password' : 'new-password'}
            />
          </label>
          {!isInitialized && (
            <label>
              Conferma password
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                autoComplete="new-password"
              />
            </label>
          )}
          {error && <div className="error">{error}</div>}
          <button type="submit" disabled={loading} aria-busy={loading}>
            {loading && <span className="btn-spinner" aria-hidden="true" />}
            {loading
              ? 'Elaborazione…'
              : isInitialized
                ? 'Accedi'
                : 'Imposta master password'}
          </button>
          {!isInitialized && (
            <p className="hint">
              Prima esecuzione: la master password che inserisci diventerà l'unica
              chiave per accedere ai tuoi dati. Non è recuperabile in nessun modo —
              custodiscila in luogo sicuro.
            </p>
          )}
        </form>
      </div>
    </div>
  )
}
